import { render, staticRenderFns } from "./SignUpJuridicaForm.vue?vue&type=template&id=26743c84"
import script from "./SignUpJuridicaForm.vue?vue&type=script&lang=js"
export * from "./SignUpJuridicaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports